import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const ExpenseAccountHeader = ({
  column,
}: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Sachkonto"
      style={{ padding: "5px" }}
    />
  );
};
